/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import useData from "../../hooks/useData";
import FormInputs from "../FormInputs";
import {updateFunerariumMainInfos} from "../../api/pro/funerariumReq";
import useAuth from "../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import FormButtons from "../../components/common/FormButtons";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormFunerariumGeneralInfos({ legend, setShowModal, apiFunerariumGeneralInfos }) {
    const { funerariumInfos } = useData();
    const [ values, setValues ] = useState();
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        if (e.target.type === "checkbox") {
            setValues({...values, [e.target.name] : e.target.checked})
        }
        validateFormInput(e)
    };

    const handleRemoveModal = () => {
        setShowModal(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id : values?.id || 0,
            agencyId : agencyId,
            name : values?.name,
            surname : values?.surname,
            useAgencyAddress : values?.useAgencyAddress || false
        }
        await updateFunerariumMainInfos(token, body)
            .then(response => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiFunerariumGeneralInfos();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    useEffect(() => {
        setValues(funerariumInfos);
    }, [ funerariumInfos ]);


    const inputs = [
        {
            id : 1,
            name : "name",
            type : "text",
            placeholder : "Nom du lieu",
            label : "Nom du lieu",
            required : true,
            pattern : patternListChoices?.name,
        },
        {
            id : 2,
            type : "select",
            name : "surname",
            options : [
                { 'Athanée' : "Athanée" },
                { 'Chambre funéraire' : "Chambre funéraire"},
                { 'Salon funéraire' : "Salon funéraire"},
                { 'Maison funéraire' : "Maison funéraire"},
                { 'Pavillon funéraire' : "Pavillon funéraire"},
                { 'Complexe funéraire' : "Complexe funéraire"}
            ],
            label : "Intitulé de funérarium",
            selected : values?.surname,
            required: true,
        },
        {
            id : 3,
            name : "useAgencyAddress",
            type : "checkbox",
            label : "Utiliser l'adresse de l'agence ?",
        }
    ];

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon span={legend} source="fa fa-house"/>}
                {inputs.map(input => (
                    <FormInputs
                        type={input.type}
                        name={input.name}
                        id={input.id}
                        label={input.label}
                        placeholder={input.placeholder}
                        value={values?.[input.name]}
                        onChange={onChange}
                        required={input.required}
                        options={input.options}
                        selected={input.selected}
                        checked={input.checked}
                        pattern={input.pattern}
                        className={input.className}
                    />
                ))}
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}